// Desktop ToDesktop update-check result, distinct from proto StatusUpdate.
// The used Electron path (todesktop.autoUpdater) never wrote a failure
// into state-sync, so the UI treated every miss as "Up To Date".
//
// Per rule: think-in-systems (ai.knowledge/global) — one signal per job.

let checkFailed = false;
const listeners = new Set<() => void>();

export function setDesktopUpdateCheckFailed(next: boolean): void {
  if (checkFailed === next) {
    return;
  }
  checkFailed = next;
  listeners.forEach((fn) => fn());
}

export function getDesktopUpdateCheckFailed(): boolean {
  return checkFailed;
}

export function subscribeDesktopUpdateCheckFailed(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export type DesktopUpdateIdleLabel = 'check-failed' | 'up-to-date' | null;

// Idle-row copy: hide "Up To Date" when the last check failed.
export function desktopUpdateIdleLabel(opts: {
  updateAvailable?: boolean;
  checkFailed?: boolean;
}): DesktopUpdateIdleLabel {
  if (opts.updateAvailable) {
    return null;
  }
  if (opts.checkFailed) {
    return 'check-failed';
  }
  return 'up-to-date';
}
